import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'schoolCategorys'

type TSchoolCategory = {
  _id: string
  display: string
  _firmId?: string
  authorId?: string
  modifiedBy?: string[]
}

const getFirm = (axios: IFactoryFunctionRequest<TSchoolCategory[], undefined>) => (firmId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/${firmId}`,
  })
}

const create = (axios: IFactoryFunctionRequest<TSchoolCategory, Partial<TSchoolCategory>>) => (data: Partial<TSchoolCategory>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<TSchoolCategory, Partial<TSchoolCategory>>) => (schoolCategoryId: string, data: Partial<TSchoolCategory>) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${schoolCategoryId}`,
    data,
  })
}

export default (axios: AxiosInstance) => ({
  getFirm: getFirm(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
})
